import { TABLE_BODY_INFO, TABLE_BODY_INFO2, TABLE_HEADER_INFO } from "util/tableVariable.js";
import { TABLE_DATA } from "util";
import { renderToString } from "react-dom/server";
import update from "immutability-helper";
const NONE_TEXT = "#AAA";
const BORDER = "1pt solid #000";

const table_render = (type, sheet, review, external) => {
    const tbl = sheet[type];
    const header = sheet["header"];
    const so = sheet["sub"];
    const table = document.createElement("table");
    table.classList.add("bpl-table", "reviewable");

    const master = sheet['master'];
    const tblNm = master?.projectNm+master?.mbrNo;
    

    table.style.border = "none";

    /*
        Header
    */
    table.innerHTML = renderToString(TABLE_DATA?.header?.[type](header, false, null, external, true, false));

    /*
        Body
    */

    const tbody = document.createElement("tbody");

    const SEPERATOR = type === "composition" ? "/" : " ";

    let remarks = [];
    let remarkNum = null;

    const TABLE_INFO = external ? TABLE_BODY_INFO[type] : TABLE_BODY_INFO2[type];

    if (type === "composition") {
        for (let d2 of tbl) {
            let tr2 = document.createElement("tr");
            tr2.dataset.uniquecode = d2.uniqueCode;
            let remarkStr = "";
            let remarkVal = d2.remark;
            if (remarkVal && remarkVal !== "FALSE" && remarkVal !== "") {
                // remarks.push({ value: d2.remark || "", uniqueCode: [d2.uniqueCode], celNm: "remark" });
                // remarkStr = "[" + remarks.length + "]";

                remarkNum = remarks.findIndex(row => remarkVal === row.value)
                if (remarkNum < 0) {
                    remarks.push({
                        value: remarkVal,
                        uniqueCode: [d2.uniqueCode],
                        celNm: "remark",
                    });
                    remarkNum = remarks.length;
                } else {
                    remarks = update(remarks, {
                        [remarkNum]: {$set: {...remarks[remarkNum], uniqueCode: [...remarks[remarkNum].uniqueCode,d2.uniqueCode]}}
                    })
                    remarkNum = remarkNum + 1;
                }
                remarkStr = "[" + remarkNum + "]";
            }
            let j = 0;
            for (let body_info of TABLE_INFO) {
                let td2 = document.createElement("td");
                td2.dataset.cellnm = body_info;

                const chk = body_info.split("+");
                if (chk.length > 1 && (d2[chk[0]] + d2[chk[1]]).length > 0) {
                    td2.style.textAlign = "center";
                    td2.innerText = (d2[chk[0]] || "") + " " + SEPERATOR + " " + (d2[chk[1]] || "");
                } else {
                    td2.innerText = d2[chk[0]] || "";
                }
                if (td2.innerText.replaceAll(/[ /]/g, "").length < 1) {
                    td2.style.backgroundColor = NONE_TEXT;
                }
                if (j < 1) {
                    td2.innerText = `${td2.innerText} ${remarkStr}`;
                    remarkStr = "";
                    j++;
                }

                const cellnm = chk?.[1] || chk?.[0];

                const reviewChk = review.find(
                    (f) => f.uniqueCode === d2.uniqueCode && ((cellnm === "unit2" && "unit1+unit2" === f.celNm) || (cellnm !== "unit2" && cellnm === f.celNm))

                );
                if (reviewChk) {
                    td2.classList.add("review");

                    if (reviewChk.cmptType === "C") {
                        td2.classList.add("complete");
                    }
                }

                tr2.appendChild(td2);
            }
            tbody.appendChild(tr2);
        }
    } else {
        for (let d1 in tbl) {
            let remarkVal = so[d1][type + "Remark"];
            if (tbl[d1]?.filter((f) => f.hide !== "TRUE").length < 1 && remarkVal === "FALSE") {
                // if (tbl[d1]?.filter((f) => f.hide !== "TRUE").length < 1) {
                continue;
            }

            let tr1 = document.createElement("tr");

            let td1 = document.createElement("td");
            td1.colSpan = TABLE_INFO.length;

            td1.style.textAlign = "center";
            td1.style.fontWeight = "bold";
            td1.style.padding = "5pt";

            let remarkStr = "";
            
            if (remarkVal && remarkVal !== "FALSE" && remarkVal !== "") {
                remarkNum = remarks.findIndex(row => remarkVal === row.value)
                if (remarkNum < 0) {
                    remarks.push({
                        value: remarkVal,
                        uniqueCode: [so[d1]?.uniqueCode],
                        celNm: type + "Remark",
                    });
                    remarkNum = remarks.length;
                } else {
                    remarks = update(remarks, {
                        [remarkNum]: {$set: {...remarks[remarkNum], uniqueCode: [...remarks[remarkNum].uniqueCode,so[d1]?.uniqueCode]}}
                    })
                    remarkNum = remarkNum + 1;
                }
                remarkStr = "[" + remarkNum + "]";
            }
            const reviewChkSub = review.find(
                (f) => f.uniqueCode === so[d1]?.uniqueCode && f.celNm === "desc"
            );
            if (reviewChkSub) {
                td1.classList.add("review");

                if (reviewChkSub.cmptType === "C") {
                    td1.classList.add("complete");
                }
            }

            td1.innerText = `${so[d1]["description"]} ${remarkStr}`;
            td1.dataset.cellnm = "desc";

            tr1.appendChild(td1);
            tr1.dataset.uniquecode = so[d1]?.uniqueCode;

            tbody.appendChild(tr1);

            remarkNum = null;

            for (let d2 of tbl[d1]) {
                if (d2.hide !== "TRUE") {
                    let tr2 = document.createElement("tr");

                    tr2.dataset.uniquecode = d2.uniqueCode;

                    let remarkStr = "";
                    if (d2.remark && d2.remark !== "FALSE" && d2.remark !== "") {
                        let remarkNum = remarks.findIndex(row => d2.remark === row.value)
                        if (remarkNum < 0) {
                            remarks.push({
                                value: d2.remark,
                                uniqueCode: [d2.uniqueCode],
                                celNm: "remark",
                            });
                            remarkNum = remarks.length;
                        } else {
                            remarks = update(remarks, {
                                [remarkNum]: {$set: {...remarks[remarkNum], uniqueCode: [...remarks[remarkNum].uniqueCode,d2.uniqueCode]}}
                            })
                            remarkNum = remarkNum + 1;
                        }
                        remarkStr = "[" + remarkNum + "]";
                    }

                    let j = 0;
                    for (let body_info of TABLE_INFO) {
                        let td2 = document.createElement("td");

                        let chk = body_info.split("+");

                        const cellnm = chk?.[1] || chk?.[0];
                        td2.dataset.cellnm = cellnm;

                        const reviewChk = review.find(
                            (f) => f.uniqueCode === d2.uniqueCode && f.celNm === cellnm
                        );
                        if (reviewChk) {
                            td2.classList.add("review");

                            if (reviewChk.cmptType === "C") {
                                td2.classList.add("complete");
                            }
                        }
                        if (chk.length > 1 && !chk[1]?.includes("Cd") && !chk[1]?.includes("Critical")) {
                            td2.innerText = (d2[chk[0]] || "") + SEPERATOR + (d2[chk[1]] || "");
                        } else {
                            td2.innerText = d2[chk[0]] || "";
                        }

                        if (td2.innerText.replaceAll(" ", "").length < 1) {
                            td2.style.backgroundColor = NONE_TEXT;
                        }
                        if (j < 1) {
                            td2.innerText = `${td2.innerText} ${remarkStr}`;
                            remarkStr = "";
                            j++;
                        }
                        if(td2.dataset.cellnm === "unit" || td2.dataset.cellnm === "rcvCritical" || td2.dataset.cellnm === "sopNo" ||
                           td2.dataset.cellnm === "testMethod" || td2.dataset.cellnm === "sndCritical"
                        ){
                            td2.style.textAlign = "center";
                        }
                        tr2.appendChild(td2);
                    }
                    tbody.appendChild(tr2);
                }
            }
        }
    }

    table.appendChild(tbody);
    const figure = document.createElement("figure");
    figure.classList.add("data-table-figure", "table");
    figure.style.width = "100%";
    figure.appendChild(table);

    const pageDiv = document.createElement("div");

    const mainDesc = sheet?.master?.description;

    switch (type.toString().toUpperCase()) {
        case "IN":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Operational Parameter${mainDesc && " (" + mainDesc + ")"
                }</h4>`;
            break;
        case "OUT":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Performance Parameter${mainDesc && " (" + mainDesc + ")"
                }</h4>`;
            break;
        case "QC":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Performance Parameter - QC${mainDesc && " (" + mainDesc + ")"
                }</h4>`;
            break;
        case "COMPOSITION":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Composition${mainDesc && " (" + mainDesc + ")"
                }</h4>`;
            break;
        default:
            break;
    }

    if (!tbody.innerHTML) {
        const p = document.createElement("p");
        p.style.fontSize = "1.1rem";
        p.innerText = "Not applicable";

        pageDiv.appendChild(p);
    } else {
        const figcaption = document.createElement("figcaption");
        figcaption.dataset.tblnm = tblNm.toUpperCase();
        figcaption.dataset.tbltp = type.toUpperCase();
        figcaption.innerText = pageDiv.querySelector("h4").innerText;
        figure.appendChild(figcaption);

        pageDiv.appendChild(figure);

        if (remarks.length > 0) {

            const ul = document.createElement("ul");
            for (let i in remarks) {
                let li = document.createElement("li");
                li.style.fontSize = "8pt";
                const reviewChk = review.find((f) => remarks[i].uniqueCode.join(",").includes(f.uniqueCode) && f.celNm.toLowerCase().includes("remark"));
                const reviewChkR = review.find((e) => remarks[i].uniqueCode.join(",").includes(e.uniqueCode) && e.celNm.toLowerCase().includes("remark") && e.cmptType.match(/R/));

                if (reviewChk) {
                    li.classList.add("review");
                    if (reviewChk.cmptType === "C") {
                        li.classList.add("complete");
                        if (reviewChkR){
                            li.classList.remove("complete");
                        }
                    }
                }

                li.innerText = "[" + (parseInt(i) + 1) + "] " + remarks[i].value;
                li.dataset.cellnm = remarks[i].celNm;
                li.dataset.uniquecode = remarks[i].uniqueCode.join(",");
                ul.appendChild(li);
            }
            ul.style.listStyle = "none";
            ul.classList.add("reviewable", "bpl-remark-ul");

            pageDiv.appendChild(ul);
        }
    }

    return pageDiv.innerHTML;
};

export default table_render;
